export default {
  text: 'text',
  layout: 'layout',
  dropZone: 'drop-zone',
  clipart: 'clipart',
  background: 'background',
  calendar: 'calendar',
};
